import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, RefreshCw, BookOpen, Users } from 'lucide-react';
import '../styles/Home.css';
import '../styles/Start.css';

const Start = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="gybtc-container">
      {/* Header */}
      <header className={`gybtc-header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="gybtc-header-content">
          <div className="gybtc-logo-container">
            <Link to="/">
              <img
                src="/gybtc-logo.png"
                alt="Grow Your BTC Logo"
                className="gybtc-logo"
              />
            </Link>
          </div>

          <nav className={`gybtc-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <Link 
              to="/" 
              className="gybtc-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <a
              href="https://growyourbtc.gumroad.com/l/10rules"
              className="gybtc-btn-nav-cta"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Get the Rule Book
            </a>
          </nav>

          <button
            className="gybtc-mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {/* Section 1 — Opening */}
      <section className="gybtc-start-hero">
        <div className="gybtc-start-bg-glow" />
        <div className="gybtc-start-content">
          <h1 className="gybtc-start-title">Where to go from here</h1>
          
          <div className="gybtc-start-opening">
            <p className="gybtc-start-text">
              If you've read the guide, you've already taken a step most people never take.
            </p>
            <p className="gybtc-start-text">
              You don't need to rush.<br />
              You don't need to chase anything.
            </p>
            <p className="gybtc-start-text gybtc-start-text-emphasis">
              This is about understanding first.
            </p>
          </div>
        </div>
      </section>

      {/* Section 2 — Three Paths */}
      <section className="gybtc-start-paths">
        <div className="gybtc-start-paths-grid">
          {/* Option 1 */}
          <div className="gybtc-start-path-card">
            <div className="gybtc-start-path-icon">
              <RefreshCw size={32} />
            </div>
            <h3 className="gybtc-start-path-title">Go deeper yourself</h3>
            <p className="gybtc-start-path-text">
              Re-read the guide. Take notes. Sit with the ideas. Move slowly and build real understanding.
            </p>
          </div>

          {/* Option 2 */}
          <div className="gybtc-start-path-card">
            <div className="gybtc-start-path-icon">
              <BookOpen size={32} />
            </div>
            <h3 className="gybtc-start-path-title">Keep learning</h3>
            <p className="gybtc-start-path-text">
              Stay connected and continue receiving practical insights that help you think clearly about Bitcoin.
            </p>
          </div>

          {/* Option 3 */}
          <div className="gybtc-start-path-card">
            <div className="gybtc-start-path-icon">
              <Users size={32} />
            </div>
            <h3 className="gybtc-start-path-title">Get help</h3>
            <p className="gybtc-start-path-text">
              If you want clarity faster, I can help you 1-on-1.
            </p>
            <Link to="/book" className="gybtc-start-path-btn">
              Book a session
            </Link>
          </div>
        </div>
      </section>

      {/* Section 3 — Closing */}
      <section className="gybtc-start-closing">
        <div className="gybtc-start-closing-content">
          <p className="gybtc-start-closing-text">
            Move at your own pace. The important thing is that you've started.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="gybtc-footer">
        <div className="gybtc-footer-content">
          <p className="gybtc-footer-text">
            © 2025 Grow Your BTC{" • "}
            <Link to="/privacy">Privacy Policy</Link>{" • "}
            <Link to="/terms">Terms</Link>{" • "}
            <Link to="/disclaimer">Disclaimer</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Start;
